import githubLight from "../assets/githubLight.webp";

export default function Navbar() {
  const colors = {
    bg: "#fff",
    text: "#000",
    sub: "#4b5563",
    border: "#e5e7eb",
    box: "white",
  };

  const styles = {
    nav: {
      width: "100%",
      backgroundColor: colors.bg,
    },
    container: {
      maxWidth: "1120px",
      margin: "0 auto",
      padding: "0px 10px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
    logo: {
      fontSize: "20px",
      fontWeight: "700",
      color: colors.text,
    },
    spaceBetween: {
      width: "100%",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    rightRow: {
      display: "flex",
      alignItems: "center",
      gap: "16px",
    },
  };

  return (
    <nav style={styles.nav}>
      <div style={styles.container}>
        <div style={styles.spaceBetween}>
          {/* LEFT */}
          <h1 style={styles.logo}>COMPUI.IN</h1>

          {/* RIGHT */}
          <div style={styles.rightRow}>
            {/* GitHub */}
            <img
              src={githubLight}
              alt="GitHub"
              style={{ height: "32px" }}
            />
          </div>
        </div>
      </div>
    </nav>
  );
}